import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import { Box } from "@mui/material";
import ProgressCom from "../../../components/ProgressCom";
import CustomPagination from "../../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";
import ClearIcon from "@mui/icons-material/Clear";
import { UseDiscountCode } from "./UseDiscountCode";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteRow from "../../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { rsProgress, rsParentChilds } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import SelectGroup from "../../../ContentManagement/firstPage/HomeOffer/SelectGroup";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function CodeGroup(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const {
    getDiscountCodeGroup,
    addDiscountCodeGroup,
    deleteDiscountCodeGroup,
  } = UseDiscountCode();
  const [products, setGroups] = useState([]);
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [parentID, setParentID] = useRecoilState(rsParentChilds);

  const [name, setName] = useState("");
  const [addGroup, setAddGroup] = useState(false);
  const [stateAdd, setStateAdd] = useState({
    discountID: props.DiscountID,
    groupID: "",
  });

  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  useEffect(() => {
    if (props.DiscountID) {
      setProgress(true);
      getDiscountCodeGroup(props.DiscountID, (callback) => {
        setGroups(callback);
      });
    }
  }, [props.DiscountID]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "groupName",
      width: 180,
      align: "center",
      headerName: "نام گروه",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.groupName}
          </Typography>
        );
      },
    },
    {
      field: "حذف",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "حذف",
      renderCell: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setDeleteState({
                show: true,
                name: cellValues.row.groupID,
                id: cellValues.row.id,
              });
            }}
          >
            <DeleteIcon sx={{ color: "MyColor.main" }} />
          </IconButton>
        );
      },
    },
    {
      field: "addGroup",
      width: 60,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setParentID({
                id: null,
                name: undefined,
              });
              setAddGroup(true);
            }}
          >
            <AddCircleIcon sx={{ color: "primary.main" }} />
          </IconButton>
        );
      },
    },
  ];

  return (
    <Dialog
      PaperProps={
        {
          // elevation: 1,
        }
      }
      sx={{ zIndex: 200 }}
      fullWidth
      maxWidth={addGroup ? "lg" : "sm"}
      open={props.showGroups}
      onClose={() => props.setShowGroups(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        sx={{ p: 1, px: 2 }}
        color="secondary"
        id="alert-dialog-title"
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {!addGroup ? (
            <Typography color="secondary" variant="subtitle2">
              لیست گروه ها
            </Typography>
          ) : (
            <Typography variant="subtitle2">گروه را انتخاب کنید</Typography>
          )}
          {!addGroup ? (
            <IconButton
              onClick={() => {
                props.setShowGroups(false);
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ) : (
            <IconButton
              onClick={() => {
                setStateAdd({ ...stateAdd, groupID: undefined });
                setAddGroup(false);
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </DialogTitle>
      <DialogContent>
        {!addGroup ? (
          <Box sx={{ height: "18rem" }}>
            {products ? (
              <DataGrid
                localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
                columns={columns}
                rows={products ? products : []}
                page={pageState.page - 1}
                pageSize={20}
                Pagination
                onPageChange={(newPage) => {
                  setPageState((old) => ({ ...pageState, page: newPage + 1 }));
                }}
                rowCount={products && products.length ? products.length : 1}
                disableColumnMenu
                hideFooterSelectedRowCount
                components={{
                  Pagination: CustomPagination,
                }}
                componentsProps={{
                  pagination: {
                    nofab: true,
                    noPageCount: true,
                    rowCount:
                      products && products.length ? products.length : "",
                  },
                }}
                initialState={{
                  sorting: {
                    sortModel: [
                      {
                        field: "id",
                        sort: "asc",
                      },
                    ],
                  },
                }}
              />
            ) : (
              <ProgressCom></ProgressCom>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <SelectGroup
              Offer
              setName={setName}
              selectedGroupID={stateAdd.groupID ? stateAdd.groupID : undefined}
              setter={setStateAdd}
              lvl1State={stateAdd}
            ></SelectGroup>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 3,
              }}
            >
              <Button
                variant="contained"
                sx={{ mr: 2 }}
                onClick={() => {
                  if (!stateAdd.groupID) {
                    enqueueSnackbar("گروه را انتخاب کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  addDiscountCodeGroup(stateAdd, () => {
                    setProgress(true);
                    getDiscountCodeGroup(stateAdd.discountID, (callback) => {
                      setGroups(callback);
                    });
                    props.callback(props.DiscountID);
                    setAddGroup(false);
                    setParentID({
                      id: null,
                      name: undefined,
                    });
                    setStateAdd({ ...stateAdd, groupID: undefined });
                  });
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    if (!stateAdd.groupID) {
                      enqueueSnackbar("گروه را انتخاب کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                        preventDuplicate: true,
                      });
                      return;
                    }
                    addDiscountCodeGroup(stateAdd, () => {
                      setProgress(true);
                      setParentID({
                        id: null,
                        name: undefined,
                      });
                      setStateAdd({ ...stateAdd, groupID: undefined });
                      getDiscountCodeGroup(stateAdd.discountID, (callback) => {
                        setGroups(callback);
                      });
                      props.callback(props.DiscountID);
                      setAddGroup(false);
                    });
                  }
                }}
              >
                ثبت
              </Button>
              <Button
                onClick={() => props.setShowGroups(false)}
                color="secondary"
                variant="outlined"
              >
                انصراف
              </Button>
            </Box>
          </Box>
        )}
        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={"گروه"}
          callback={() => {
            setProgress(true);
            deleteDiscountCodeGroup(deleteState.id, () => {
              getDiscountCodeGroup(props.DiscountID, (callback) => {
                props.callback(props.DiscountID);
                setGroups(callback);
              });
            });
          }}
        ></DeleteRow>
      </DialogContent>
    </Dialog>
  );
}
